import { carrierTrackingUrl } from "@pages/AdminDashboard/externalLinks";
import { ExternalLink } from "@pages/AdminDashboard/ui/DataTable/cells";
import { CaseOrderSummary, OrderStatuses } from "@types-runway/case";

const noValue = "—";
const notShippedYet = "Not shipped yet";

// The carrier and tracking number as a link to the carrier's page, "Not shipped yet" before the
// Order ships, or a dash for a cancelled Order with none (ACCT-R13, XCUT-R24).
export const OrderTracking = ({ order }: { order: CaseOrderSummary }) => {
  const { carrier, tracking_number: trackingNumber, status } = order;

  if (!trackingNumber) return <>{status === OrderStatuses.CANCELLED ? noValue : notShippedYet}</>;

  const text = carrier ? `${carrier.toUpperCase()} · ${trackingNumber}` : trackingNumber;
  const trackingUrl = carrierTrackingUrl(carrier, trackingNumber);

  return trackingUrl ? <ExternalLink href={trackingUrl}>{text}</ExternalLink> : <>{text}</>;
};
